import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import type { WrappedComponentProps } from 'react-intl';

import { token } from '@atlaskit/tokens';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';

type ExcerptIncludeErrorComponentProps = {
	targetContentTitle: string;
};

class ExcerptIncludeErrorComponent extends PureComponent<
	ExcerptIncludeErrorComponentProps & WrappedComponentProps
> {
	render() {
		const { targetContentTitle, intl } = this.props;

		return (
			<span
				style={{
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					display: 'inline-block',
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					backgroundColor: token('elevation.surface'),
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					borderRadius: 5,
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					width: 668,
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					height: 25,
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					padding: token('space.050'),
				}}
			>
				<StatusWarningIcon label="" color={token('color.icon')} />
				<span
					style={{
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						paddingLeft: token('space.050'),
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						verticalAlign: 'text-bottom',
					}}
				>
					{intl.formatMessage(
						{
							id: 'editor.excerpt.include.macro.error',
						},
						{
							0: targetContentTitle,
						},
					)}
				</span>
			</span>
		);
	}
}

export const ExcerptIncludeError = injectIntl(ExcerptIncludeErrorComponent);
